import React, { useState } from "react";

const FAQ = ({ question, answer, index }) => {
  const [isOpen, setIsOpen] = useState(false);
  const answerId = `faq-answer-${index}`;

  const toggleAnswer = () => setIsOpen((open) => !open);

  return (
    <div className="overflow-hidden rounded-xl border border-sky-200 bg-white/90 transition-colors hover:border-blue-300">
      <button
        type="button"
        className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left sm:px-5 sm:py-[1.125rem]"
        onClick={toggleAnswer}
        aria-expanded={isOpen}
        aria-controls={answerId}
      >
        <span className="text-base font-semibold leading-6 text-stone-800 sm:text-lg">
          {question}
        </span>
        <span
          aria-hidden="true"
          className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-lg font-medium transition-colors ${
            isOpen
              ? "bg-blue-800 text-white"
              : "bg-sky-100 text-blue-900"
          }`}
        >
          {isOpen ? "−" : "+"}
        </span>
      </button>
      {isOpen && (
        <div
          id={answerId}
          className="border-t border-sky-100 px-4 pb-5 pt-4 sm:px-5"
        >
          <p className="text-sm leading-7 text-stone-700 sm:text-base">
            {answer}
          </p>
        </div>
      )}
    </div>
  );
};

export default FAQ;
